import { FC, MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  buildCourseRouteTypeTooltipContent,
  CourseIndicatorIcon,
  FramerTooltip,
} from "@ryde/controls";
import { useDrawers, useHaveCustomPermissions } from "@ryde/shared";

import { ICoursesCalendarRideProduceCourseLinkProps } from "./courses-calendar-ride-produce.models";

export const CoursesCalendarRideProduceCourseLink: FC<
  ICoursesCalendarRideProduceCourseLinkProps
> = ({ slot }) => {
  const { t } = useTranslation();
  const { openCourseEditFormDrawer } = useDrawers();
  const { canOpenCourseDrawer } = useHaveCustomPermissions();
  const { courseId, courseName, courseRouteType } = slot;

  const onCourseClick = useEvent((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (!canOpenCourseDrawer) {
      return;
    }
    void openCourseEditFormDrawer({ id: courseId });
  });

  const routeTypeTooltip = buildCourseRouteTypeTooltipContent({
    t,
    courseId,
    courseName,
    routeType: courseRouteType,
    courseTotalDuration: slot.courseTotalDuration,
    courseStationsCount: slot.courseStationsCount,
  });

  const courseIdNode = canOpenCourseDrawer ? (
    <button
      type="button"
      className="cc-ride-produce-course-link"
      onClick={onCourseClick}
    >
      {courseId}
    </button>
  ) : (
    <span>{courseId}</span>
  );

  return (
    <span className="cc-ride-produce-course-cell">
      <FramerTooltip content={routeTypeTooltip}>
        <span className="cc-ride-produce-course-type-icon">
          <CourseIndicatorIcon routeType={courseRouteType} />
        </span>
      </FramerTooltip>
      {courseIdNode}
      {courseName ? (
        <span className="cc-ride-produce-course-name">{courseName}</span>
      ) : null}
    </span>
  );
};
